import React from 'react';

import { TheoryPreviewBlock } from 'components/TheoryPreviewBlock';

import { Action } from '../Action';

import styles from './PluginPreviewPage.module.scss';

const PluginPreviewPage = ({
  nextLoading,
  isLastLessonInCourse,
  lesson,
  onNextLessonClick,
  isTestMode,
}: {
  nextLoading: any;
  isLastLessonInCourse: any;
  lesson: any;
  onNextLessonClick: any;
  isTestMode: any;
}) => (
  <div className={styles.page}>
    <div className={styles.inner}>
      {lesson.blocks.map((block: any) => (
        <TheoryPreviewBlock type={block.type} data={block.data} />
      ))}
      <div className={styles.actions}>
        {isTestMode && (
          <Action
            nextLoading={nextLoading}
            isLastLessonInCourse={isLastLessonInCourse}
            onClick={onNextLessonClick}
          />
        )}
      </div>
    </div>
  </div>
);

export default React.memo(PluginPreviewPage) as any;
